import React from 'react';
import styled from '@emotion/styled';

import { mq } from '../../_style';

const Article = styled.article`
  max-width: 640px;
  margin-right: auto;
  margin-left: auto;
`;

const ArticleBody = (props) => {
  return(
    <Article>{props.children}</Article>
  );
};
export default ArticleBody;
